<template>
  <div>
    <v-progress-linear
      v-if="loading && !rcovidResponse"
      indeterminate
      color="rgb(86, 160, 153)"
      style="margin-top:20px;"
    />
    <v-data-table
      :headers="headers"
      :items="rcovidResponse"
      sort-by="calories"
      class="elevation-1"
      :items-per-page="itemsPerPage"
      :loading="loading"
      hideDefaultFooter
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>{{$t('rcovid.title')}}</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <!-- <v-spacer /> -->
          <v-btn v-if="rcovidResponse" @click="handleExportToPDF"><v-icon>mdi-file-pdf</v-icon></v-btn>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-spacer />
          <v-text-field
            solo
            :label="$t('common.search')"
            append-icon="mdi-magnify"
            style="margin-top:30px;"
            v-model="search"
            @input="handleSearch"
          />
          <v-spacer />           
        </v-toolbar>
      </template>
      <template v-slot:no-data>
        {{ $t('common.noData', locale)}}
      </template>
    </v-data-table>
    <v-layout wrap>
      <v-flex xs2>
        <v-select
            solo
            :label="$t('common.show')"
            v-model="itemsPerPage"
            :items="[
              { ID: 100000, Name: 'All'},
              { ID: 5, Name: '5'},
              { ID: 10, Name: '10'},
              { ID: 25, Name: '25'},
            ]"
            item-text="Name"
            item-value="ID"
            @change="getRCovidResponse"
            style="margin: 5px;"
          />
      </v-flex>
      <v-flex xs10 
        v-if="pageCount > 0"
        style="padding-top: 10px;padding-left: 10px;padding-right: 10px;"
      >
        <v-pagination
          v-model="page"
          :length="pageCount"
          @input="handleChangePage"
        />
      </v-flex>
    </v-layout>
    
  </div>
</template>

<script>
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'
  import _ from 'lodash'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import i18n from '@/plugins/i18n'
  export default {
    data: () => ({
      page: 1,
      loading: false,
      search: '',
      itemsPerPage: 10,
      pageCount: 0,
      headers: [
        {
          text: i18n.t('rcovid.name'),
          align: 'start',
          sortable: false,
          value: 'Name',
        },
        {
          text: i18n.t('rcovid.ni'),
          align: 'start',
          sortable: false,
          value: 'NI',
        },
        {
          text: i18n.t('rcovid.phone'),
          align: 'start',
          sortable: false,
          value: 'Phone',
        },
        {
          text: i18n.t('rcovid.LMD'),
          align: 'start',
          sortable: false,
          value: 'LMD',
        },
      ],
      rcovidResponse: [],      
    }),
    computed: {
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      locale () {
        return i18n.locale
      },
    },
    watch: {
      enterpriseID (v, old) {
        if (old !== v && v) this.getRCovidResponse ()
      }
    },
    mounted () {
      this.loading = true
      this.handleSearch = _.debounce(() => {
        this.getRCovidResponse()        
      }, 500)
      this.initialize()
    },
    methods: {
      initialize () {   
        this.getRCovidResponse()
      },
      getRCovidResponse() {
        this.loading = true
        if (this.enterpriseID)
          api.getAll(`contents/${this.enterpriseID}/rcovid`, true, this.page, this.itemsPerPage, this.search).then(response => {
            this.loading = false   
            if (response.count) {
              this.count = response.count
              let page = this.count > 0 ? parseInt(this.count / this.itemsPerPage, 10) : 0
              if (this.count > 0 && (this.count % this.itemsPerPage)!== 0) page++
              this.pageCount = page
            }
            this.rcovidResponse = response.data.map(item => {
              item.LMD = new Date(item.LMD).toLocaleDateString(this.locale) + ' ' + new Date(item.LMD).toLocaleTimeString(this.locale)
              return item
            })
          })    
      },
      getAllergenFormatted (value) {
        return this.allergens.filter(x => x.ID === value)[0].Name
      },
      handleExportToPDF () {
        const doc = new jsPDF('l')

        // It can parse html:
        // <table id="my-table"><!-- ... --></table>
        doc.autoTable({ html: '#my-table' })

        const body = []
        for (const item of this.rcovidResponse) body.push([item.Name, item.NI, item.Phone, item.LMD])        
        // Or use javascript directly:
        doc.autoTable({
          head: [[i18n.t('rcovid.name'), i18n.t('rcovid.ni'), i18n.t('rcovid.phone'), , i18n.t('rcovid.LMD')]],
          body
        })

        doc.save('table.pdf')
      },
      handleChangePage () {
        this.getRCovidResponse()
      },
    },
  }
</script>
